export enum NoDataType {
  INLINE = 'inline',
  FULL = 'full'
}

export enum NoDataSize {
  XS,
  S,
  M,
  L,
  XL
}
